export const DONE_STATUS = 'done';
export const DONE_WITH_ERRORS_STATUS = 'done_with_errors';
export const PENDING_STATUS = 'pending';
export const FAILED_STATUS = 'failed';

export const IMPORT_CONTACTS_STATUS_LABELS = {
  [DONE_STATUS]: 'Done',
  [DONE_WITH_ERRORS_STATUS]: 'Done w/Error',
  [PENDING_STATUS]: 'Processing',
  [FAILED_STATUS]: 'Failed',
};

export const importContactsReportOption = [
  {
    text: 'Recent import contacts',
    isArchivedOption: false,
  },
  {
    text: 'Archived import contacts',
    isArchivedOption: true,
  },
];

export const headers = [
  {
    text: 'Name',
    value: 'file_name',
    width: '20%',
    sortable: false,
  },
  {
    text: 'Total Records',
    value: 'contacts_total',
    width: '10%',
    sortable: false,
    showTooltip: true,
    toolTipText: 'The total number of new records created during the import process. This number may update while the import is underway.',
  },
  {
    text: 'Status',
    value: 'status',
    width: '20%',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Uploaded Records (Successful/Partials/Failed)',
    width: '30%',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Created',
    value: 'created_at',
    width: '20%',
    sortable: false,
  },
];

export const successfulHeaders = [
  {
    text: 'Name',
    value: 'name',
    sortable: false,
  },
  {
    text: 'Email',
    value: 'email',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Created date',
    value: 'created_at',
    align: 'center',
    sortable: false,
  },
];

export const partialHeaders = [
  {
    text: 'Name',
    value: 'name',
    sortable: false,
  },
  {
    text: 'Email',
    value: 'email',
    align: 'center',
    sortable: false,
  },
  {
    text: 'File position',
    value: 'file_position',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Error',
    value: 'error',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Created date',
    value: 'created_at',
    align: 'center',
    sortable: false,
  },
];

export const failedHeaders = [
  {
    text: 'File position',
    value: 'file_position',
    sortable: false,
    width: '10%'
  },
  {
    text: 'Record data',
    value: 'raw_data',
    sortable: false,
    width: '35%',
    align: 'center',
    showTooltip: true,
  },
  {
    text: 'Created date',
    value: 'created_at',
    sortable: false,
    width: '20%',
    align: 'center',
  },
  {
    text: 'Error',
    value: 'error',
    sortable: false,
    width: '35%',
    align: 'center',
  },
];
